<template>
  <div class="game-container">
    <div id="game-container"><canvas id="gameCanvas"></canvas></div>
  </div>
</template>

<script>
import _ from 'lodash';
import createjs from 'createjs-collection';
import preload from 'preload-js';
export default {
  name: 'mp-rotate-v2',
  components: {},
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      initData: {},
      stage: null,
      width: 0,
      height: 0,
      offset: {},
      images: [],
      moveTo: false,
      rotateTo: false,
    };
  },
  beforeMount() {},
  mounted() {
    //  this.initData = _.cloneDeep(this.startGameConfig);
    this.stage = new createjs.Stage('gameCanvas');
    this.stage.mouseMoveOutside = true;
    this.stage.snapToPixelEnabled = true;
    this.setStage();
    createjs.Touch.enable(this.stage);
    // console.log(createjs.Touch.isSupported());
  },
  created() {},
  methods: {
    createContainer(obj) {
      var container = new createjs.Container();
      container.x = (Number.isInteger(obj.pos.x) ? obj.pos.x : 0) - this.offset.x;
      container.y = (Number.isInteger(obj.pos.y) ? obj.pos.y : 0) - this.offset.y;
      if (obj.id) container.name = obj.id;
      if (obj.bgr.split('/').length == 1) {
        let shape = new createjs.Shape();
        container.width = shape.width = Number.isInteger(obj.pos.w) ? obj.pos.w : this.width - container.x;
        container.height = shape.height = Number.isInteger(obj.pos.h) ? obj.pos.h : this.height - container.y;
        if (obj.border) {
          shape.graphics.ss(1).s(obj.border);
        }
        shape.graphics.f(obj.bgr).dr(0, 0, shape.width, shape.height).ef();
        if (obj.id) shape.id = obj.id;
        container.addChild(shape);
        this.stage.addChild(container);
      } else {
        let queue = new preload.LoadQueue();
        var self = this;
        queue.on('fileload', function (e) {
          let bmp = new createjs.Bitmap(e.result.src);
          if (e.item.id) bmp.id = e.item.id;
          e.item.cont.width = e.result.width;
          e.item.cont.height = e.result.height;
          e.item.cont.addChild(bmp);
        });
        queue.on('complete', function (e) {
          self.stage.update();
        });
        queue.loadManifest([{ cont: container, id: obj.id, src: obj.bgr }]);
      }
      return container;
    },
    setStage() {
      this.initData = _.cloneDeep(this.startGameConfig);
      this.width = this.initData.width ? this.initData.width : document.getElementById('game-container').offsetWidth;
      this.height = this.initData.height
        ? this.initData.height
        : document.getElementById('game-container').offsetHeight;
      this.stage.canvas.width = this.width;
      this.stage.canvas.height = this.height;
      this.offset = {
        x: this.stage.canvas.width / 2,
        y: this.stage.canvas.height / 2,
      };
      this.stage.x = this.offset.x;
      this.stage.y = this.offset.y;
      this.initData.target.id = 'target';
      this.stage.addChildAt(this.createContainer(this.initData.target), this.stage.children.length);
      this.initData.source.id = 'source';
      this.stage.addChildAt(this.createContainer(this.initData.source), this.stage.children.length);
      this.createSamples();
      this.stage.update();
    },
    createSamples() {
      let pick = this.initData.pick
        ? this.initData.pick > this.initData.samples.length
          ? this.initData.samples.length
          : this.initData.pick
        : this.initData.samples.length;
      let shuffle = this.initData.shuffle ? true : false;
      var indx = [],
        self = this;
      if (shuffle) {
        for (let i = 0; i < pick; i++) {
          let ix = Math.round(Math.random() * (this.initData.samples.length - 1));
          let flg = false;
          for (let j = 0; j < indx.length; j++) if (indx[j] == ix) flg = true;
          if (flg) i--;
          else indx[i] = ix;
        }
      } else indx = Array.from({ length: pick }, (v, k) => k);
      var source = this.stage.getChildByName('source');
      var vPointH = this.initData.point.posV === true ? false : true;
      var vPointV = this.initData.point.posV === true || this.initData.point.posAll === true ? true : false;
      var count = 0;
      indx.forEach(function (ind, i) {
        let samp = self.initData.samples[ind];
        if (samp.posAll === true) {
          vPointH = true;
          vPointV = true;
        }
        if (samp.posH === true) {
          vPointH = true;
          vPointV = false;
        }
        if (samp.posV === true) {
          vPointH = false;
          vPointV = true;
        }
        if (samp.items !== undefined) {
          samp.items.forEach(function (item, j) {
            if (item.posAll === true) {
              vPointH = true;
              vPointV = true;
            }
            if (item.posH === true) {
              vPointH = true;
              vPointV = false;
            }
            if (item.posV === true) {
              vPointH = false;
              vPointV = true;
            }
            let cont = new createjs.Container();
            cont.name = 'cont-' + count;
            cont.id = samp.id + '-' + j;
            let shape = new createjs.Shape();
            if ((item.type === undefined && samp.type == 'line') || item.type == 'line') {
              let x = Number.isInteger(item.x1) ? item.x1 : 0,
                y = Number.isInteger(item.y1) ? item.y1 : 0,
                size = Number.isInteger(item.size) ? item.size : samp.size;
              shape.graphics
                .clear()
                .s(item.bgr ? item.bgr : samp.bgr)
                .ss(size)
                .mt(x, y);
              if (Number.isInteger(item.x2) && Number.isInteger(item.y2)) {
                shape.graphics.lt(item.x2, item.y2);
                cont.width = item.x2 - x < size ? item.x2 - x + size : item.x2 - x;
                cont.height = item.y2 - y < size ? item.y2 - y + size : item.y2 - y;
              } else {
                if (
                  (item.isVer === true && item.isHor !== true) ||
                  (samp.isVer === true && samp.isHor !== true) ||
                  self.initData.source.isVer === true
                ) {
                  shape.graphics.lt(Number.isInteger(item.x1) ? item.x1 : 0, item.w);
                  cont.width = (Number.isInteger(item.x1) ? item.x1 : 0 - x < size)
                    ? Number.isInteger(item.x1)
                      ? item.x1
                      : 0 - x + size
                    : Number.isInteger(item.x1)
                    ? item.x1
                    : 0 - x;
                  cont.height = item.w < size ? item.w + size : item.w;
                  shape.x = cont.width / 2;
                } else {
                  shape.graphics.lt(item.w, Number.isInteger(item.y1) ? item.y1 : 0);
                  cont.width = item.w < size ? item.w + size : item.w;
                  cont.height = (Number.isInteger(item.y1) ? item.y1 : 0 - y < size)
                    ? Number.isInteger(item.y1)
                      ? item.y1
                      : 0 - y + size
                    : Number.isInteger(item.y1)
                    ? item.y1
                    : 0 - y;
                  shape.y = cont.height / 2;
                }
              }
              shape.on('mousedown', self.stageMouseDown);
              shape.on('pressup', self.stageMouseUp);
              cont.addChild(shape);
              let rad = Number.isInteger(self.initData.point.rad) ? self.initData.point.rad : 25;
              if (vPointH) {
                let ptk1 = self.createPoint(x, y + cont.height / 2);
                let ptk2 = self.createPoint(x + cont.width, y + cont.height / 2);
                ptk1.name = 'pH-1';
                ptk1.reg = { x: x + cont.width, y: y + cont.height / 2, rad: rad };
                ptk2.name = 'pH-2';
                ptk2.reg = { x: x, y: y + cont.height / 2, rad: rad };
                cont.addChild(ptk1, ptk2);
              }
              if (vPointV) {
                cont.addChild(self.createPoint(x + cont.width / 2, y - rad));
                cont.addChild(self.createPoint(x + cont.width / 2, y + cont.height + rad));
              }
              let marg = self.initData.source.marg;
              const def = 15;
              let child = false;
              cont.x = marg !== undefined && Number.isInteger(marg.l) ? marg.l : def;
              cont.y = marg !== undefined && Number.isInteger(marg.t) ? marg.t : def;
              if (self.initData.source.isVer !== true) {
                if (i !== 0 || j !== 0) {
                  child = source.getChildByName('cont-' + (count - 1));
                  if (i > 0 && j == 0) {
                    cont.x = marg !== undefined && Number.isInteger(marg.l) ? marg.l : def;
                    cont.y =
                      child.y +
                      child.height +
                      (marg === undefined
                        ? def
                        : Number.isInteger(marg.distV)
                        ? marg.distV
                        : Number.isInteger(marg.dist)
                        ? marg.dist
                        : def);
                  }
                  if (j > 0) {
                    cont.x =
                      child.x +
                      child.width +
                      (marg === undefined
                        ? def
                        : Number.isInteger(marg.distH)
                        ? marg.distH
                        : Number.isInteger(marg.dist)
                        ? marg.dist
                        : def);
                    cont.y = child.y;
                  }
                }
              } else {
                if (i !== 0 || j !== 0) {
                  child = source.getChildByName('cont-' + (count - 1));
                  if (i > 0 && j == 0) {
                    cont.x =
                      child.x +
                      cont.width +
                      (marg === undefined
                        ? def
                        : Number.isInteger(marg.distH)
                        ? marg.distH
                        : Number.isInteger(marg.dist)
                        ? marg.dist
                        : def);
                    cont.y = marg !== undefined && Number.isInteger(marg.t) ? marg.t : def;
                  }
                  if (j > 0) {
                    cont.x = child.x;
                    cont.y =
                      child.y +
                      child.height +
                      (marg === undefined
                        ? def
                        : Number.isInteger(marg.distV)
                        ? marg.distV
                        : Number.isInteger(marg.dist)
                        ? marg.dist
                        : def);
                  }
                }
              }
            }
            cont.pos = { x: cont.x, y: cont.y };
            cont.isSelect = false;
            source.addChild(cont);
            self.images.push(cont);
            count++;
          });
        }
      });
      this.stage.update();
    },
    createPoint(x, y) {
      /*
       * TRZEBA SPRAWDZAĆ CZY KROPKI NA SIEBIE NIE NACHODZĄ I DAĆ BLOKADĘ !!!!!!!!!
       *
       */
      var point = new createjs.Shape();
      if (this.initData.point.border !== undefined) {
        point.graphics.ss(1).s(this.initData.point.border);
      }
      if (this.initData.point.bgr !== undefined) {
        point.graphics.f(this.initData.point.bgr);
      }
      point.graphics.dc(0, 0, Number.isInteger(this.initData.point.rad) ? this.initData.point.rad : 25);
      point.type = 'point';
      point.visible = false;
      point.x = x;
      point.y = y;
      point.on('mousedown', this.stageMouseDownPoint);
      point.on('pressup', this.stageMouseUpPoint);
      return point;
    },
    newGame() {
      this.mousedown = false;
      this.stage.removeAllChildren();
      this.stage.removeAllEventListeners();
      this.stage.update();
      this.images.splice(0, this.images.length);
      this.moveTo = false;
      this.setStage();
    },
    stageMouseDownPoint(e) {
      this.rotateTo = e.target.parent;
      let x = this.rotateTo.parent.x;
      let y = this.rotateTo.parent.y;
      this.rotateTo.rotate = true;
      this.stage.addChildAt(this.rotateTo, this.stage.children.length);
      this.rotateTo = this.stage.getChildByName(this.rotateTo.name);
      this.stage.on('stagemousemove', this.stageMouseMovePoint);
      this.stage.update();
      this.rotateTo.x += x;
      this.rotateTo.y += y;
      this.rotateTo.point = e.target;
      var globalPoint = e.target.parent.localToGlobal(e.target.reg.x, e.target.reg.y);
      this.rotateTo.x = globalPoint.x - this.offset.x;
      this.rotateTo.y = globalPoint.y - this.offset.y;
      var angleInRadians = Math.atan2(
        e.stageY - this.offset.y - this.rotateTo.y,
        e.stageX - this.offset.x - this.rotateTo.x
      );
      var angleInDegrees = angleInRadians * (180 / Math.PI);
      this.rotateTo.rotation = angleInDegrees;
      this.stage.update();
    },
    stageMouseMovePoint(e) {
      if (this.rotateTo.rotate) {
        var angleInRadians = Math.atan2(
          e.stageY - this.offset.y - this.rotateTo.y,
          e.stageX - this.offset.x - this.rotateTo.x
        );
        var angleInDegrees = angleInRadians * (180 / Math.PI);
        this.rotateTo.rotation = angleInDegrees;
        this.stage.update();
      }
    },
    stageMouseUpPoint(e) {
      let target = this.stage.getChildByName('target');
      this.rotateTo.rotate = false;
      this.rotateTo.x -= target.x;
      this.rotateTo.y -= target.y;
      target.addChild(this.rotateTo);
      this.rotateTo.point = null;
      this.stage.update();
      this.stage.removeAllEventListeners('stagemousemove');
    },
    stageMouseDown(e) {
      this.resetCheckStatus();
      var ix = -1;
      var target = e.target.parent;
      this.images.forEach(function (bmp, i) {
        if (target.id == bmp.id) {
          ix = i;
        }
      });
      if (ix >= 0) {
        let x = this.images[ix].parent.x;
        let y = this.images[ix].parent.y;
        let select = target.parent.name == 'target' ? true : false;
        this.stage.addChildAt(this.images[ix], this.stage.children.length);
        this.moveTo = this.images[ix];
        this.stage.update();
        this.stage.on('stagemousemove', this.stageMouseMove);
        this.moveTo.x += x;
        this.moveTo.y += y;
        this.moveTo.stageX = e.stageX - this.offset.x;
        this.moveTo.stageY = e.stageY - this.offset.y;
        this.moveTo.select = select;
        this.showHidePoints();
        this.mousedown = true;
      } else this.moveTo = null;
      this.stage.update();
    },
    stageMouseMove(e) {
      if (this.mousedown) {
        this.moveTo.x += e.stageX - this.moveTo.stageX - this.offset.x;
        this.moveTo.y += e.stageY - this.moveTo.stageY - this.offset.y;
        this.moveTo.stageX = e.stageX - this.offset.x;
        this.moveTo.stageY = e.stageY - this.offset.y;
        this.moveTo.x = Math.round(this.moveTo.x);
        this.moveTo.y = Math.round(this.moveTo.y);
        this.moveTo.select = false;
        this.moveTo.children.forEach(function (child) {
          if (child.type == 'point') child.visible = false;
        });
        this.stage.update();
      }
    },
    stageMouseUp(e) {
      if (this.mousedown) {
        this.mousedown = false;
        var items = this.stage.getObjectsUnderPoint(e.stageX - this.offset.x, e.stageY - this.offset.y);
        var drop = true;
        items.forEach(function (obj) {
          if (obj.id == 'source') drop = false;
        });
        if (drop === true) {
          let target = this.stage.getChildByName('target');
          this.moveTo.x -= target.x;
          this.moveTo.y -= target.y;
          target.addChild(this.moveTo);
          if (this.moveTo.select) {
            this.showHidePoints(this.moveTo.name);
          } else this.showHidePoints();
        } else {
          this.moveTo.x = this.moveTo.pos.x;
          this.moveTo.y = this.moveTo.pos.y;
          this.moveTo.rotation = 0;
          this.stage.getChildByName('source').addChild(this.moveTo);
        }
        this.stage.update();
        this.stage.removeAllEventListeners('stagemousemove');
      }
    },
    showHidePoints(name) {
      this.stage.getChildByName('target').children.forEach(function (item) {
        if (item.children !== undefined) {
          item.rotate = false;
          item.children.forEach(function (point) {
            if (point.type == 'point') point.visible = item.name == name && name != null ? true : false;
          });
        }
      });
      this.stage.getChildByName('source').children.forEach(function (item) {
        if (item.children !== undefined) {
          item.rotate = false;
          item.children.forEach(function (point) {
            if (point.type == 'point') point.visible = false;
          });
        }
      });
    },
    resetGameAction() {
      this.newGame();
    },
    checkGameAction() {
      var isCorrect = true;
      return isCorrect;
    },
    resetCheckStatus() {
      this.$store.dispatch('resetCheckStatus');
      return true;
    },
  },
  beforeDestroy() {
    this.stage.removeAllEventListeners();
  },
  computed: {
    checkGame() {
      return this.$store.getters.checkGame;
    },
    resetGameSwitch() {
      return this.$store.getters.resetGame;
    },
  },
  watch: {
    checkGame: function (newStatus, oldStatus) {
      if (newStatus) {
        this.$store.dispatch('checkGame', this.checkGameAction());
        this.$store.commit('CHECK_GAME', false);
      }
    },
    resetGameSwitch(newStatus, oldStatus) {
      if (newStatus) {
        this.resetGameAction();
        this.$store.dispatch('resetGame');
      }
    },
  },
};
</script>
<style lang="scss"></style>
<style lang="scss" scoped>
.game-container {
  display: flex;
  padding: 160px 50px 100px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

#game-container {
  margin: 0;
  width: 100%;
  height: 100%;
}

// canvas { border: 1px solid black; }
</style>
